import React, { useState, useEffect, useRef, useCallback}  from 'react';
import { format } from 'date-fns';
import checkIcon from './assets/check.svg';
import errorIcon from './assets/error.svg';
import infoIcon from './assets/info.svg';
import warningIcon from './assets/warning.svg';
import './Toast.css';
const DEFAULT_DATE_FORMAT = "yyyy-MM-dd hh:mm:ss"

interface Dictionary<T> {
    [Key: string]: T;
}

// define some types
export type toastListProp = {
    id: number,
    title: string,
    description: string,
    backgroundColor: string,
    icon: any,
}

export enum toastType {
    success  = 0,
    info = 1,
    warning = 2,
    error = 3,
}

const backgroundColor: Array<string> = ['#48c7fd', '#58e28d', '#f0ad4e', '#d9534f']; // blue, green, orange, red
const toastTypeIconMap : Array<any> = [checkIcon, infoIcon, warningIcon, errorIcon];


export enum positionType {
    top_right = 0,
    bottom_right = 1,
    top_left = 2,
    bottom_left = 3,
    None = 4,
}

type propsTypes = {
    toastList: Array<toastListProp>,
    position: positionType,
    autoDismiss: boolean,
    dismissTime: number,
    onCreated?: (value: number) => void,
    onDeleted?: (value: number) => void,
}

var counter: number = 0;

// utility function: create toast properties
export const createToastProperties = (type: toastType, title: string, description: any) =>{
    const id = counter++;
    const iconType = toastTypeIconMap[type];
    const bgColor = backgroundColor[type];
    var descriptionOk = description

    if(typeof description !== 'string'){
        //console.log("!! toast description is not string but:" + typeof(description));
        try{
            descriptionOk = JSON.stringify(description);
        }catch(e){
            descriptionOk = "Error getting description: not string, not json...";
        }
        //throw new Error("@@@@#####@@@@@ toast description is not string but:" + typeof(description));
    }

    const toastProperties: toastListProp = {
        id,
        title: title,
        description: descriptionOk,
        backgroundColor: bgColor,
        icon: iconType
      }
   return toastProperties;
};


//
const Toast = (props: propsTypes) => {
    const { toastList, position, autoDismiss, dismissTime, onDeleted } = props;
    const [list, setList] = useState(toastList);


    // set props.toastList in state
    useEffect(() => {
        //setList([...toastList]);
        const listCp = [...toastList];
        setList(listCp);

        if(props.onCreated!==undefined){
            for (const item in listCp){
                //props.onCreated(cp[item].id);
            }

        }

        // eslint-disable-next-line
    }, [toastList, props.onCreated]);

    // Store latest values in refs to avoid recreating interval on every state change
    const toastListRef = useRef(toastList);
    const listRef = useRef(list);

    useEffect(() => {
        toastListRef.current = toastList;
        listRef.current = list;
    }, [toastList, list]);

    //
    // when toast X is clicked: remove the toast from list
    //
    const deleteToast = useCallback((id: number) => {
        //console.log("@@@@@@@@@@@@@ Toast: will remove id:"+id);
        setList(prevList => {
            const listItemIndex = prevList.findIndex(e => e.id === id);
            if (listItemIndex !== -1) {
                const newList = [...prevList];
                newList.splice(listItemIndex, 1);
                return newList;
            }
            return prevList;
        });
        //
        if(onDeleted!==undefined){
            onDeleted(id);
        }
    }, [onDeleted]);

    // use effect to remove one toast every dismissTime delay
    // Only recreate interval when autoDismiss or dismissTime changes, NOT when lists change
    useEffect(() => {
        if (!autoDismiss) return;

        const interval = setInterval(() => {
            // Use refs to access latest values without triggering effect recreation
            if (toastListRef.current.length && listRef.current.length) {
                deleteToast(toastListRef.current[0].id);
            }
        }, dismissTime);

        return () => {
            clearInterval(interval);
        }

        // eslint-disable-next-line
    }, [autoDismiss, dismissTime, deleteToast]);

    const aDate = new Date();
    const aDateStr =  format(aDate, DEFAULT_DATE_FORMAT)

    return (
        <>
            <div className={`notification-container ${positionType[position]}`}>
                {
                    list.map((toast, i) =>     
                        <div 
                            key={i}
                            className={`notification glToast ${positionType[position]}`}
                            style={{ backgroundColor: toast.backgroundColor }}
                            >
                            <button onClick={() => deleteToast(toast.id)}>
                                X
                            </button>
                            <div className="notification-image">
                                <img src={toast.icon} alt="" />
                            </div>
                            <div>
                                <p className="notification-title">{toast.title}</p>
                                <p className="notification-message">
                                    {toast.description}
                                </p>
                                <p className="notification-date">At: {aDateStr}</p>
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    );
}

export default React.memo(Toast);